export const colors = {
  primaryColor: "#D55730",
  primaryColorDarker: "#9E3A1B",
  secondaryColor: "#43ACA5",
  darkColor: "#393841",
  reallyDarkColor: "#272727",
  grayGreen: "#CCD8CE",
  lightGray: "#C4C4C4",
  darkGreen: "#08766F",
  lightGreen: "#43ACA5",
  whitish: "#E8E8E8",
  middlegreen: "#898F93",
  ligthRed: "#F33F30",
  darkRed: "#A41C11"
};
